<template>
    <div class="search-wrap">
        <slot name="searchForm"></slot>
        <SearchViewButton v-if="getShowCollapseButton" :tabName="getTabName"></SearchViewButton>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

export default defineComponent({
    name: "SearchWrap",
    props: {
        tabName: {
            default: "",
            type: String
        },
        showCollapseButton: {
            default: false,
            type: Boolean
        }
    },
    setup(props) {
        let getTabName = computed(() => {
            return props.tabName
        })

        let getShowCollapseButton = computed(() => {
            return props.showCollapseButton
        })

        return {
            getTabName,
            getShowCollapseButton
        }
    }
});
</script>